import ScriptEditorDialog from './ScriptEditorDialog';

export default ScriptEditorDialog;
